import React from 'react'
import { connect } from 'react-redux'
import { lineups } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'

const LineupsLoader = ({ children, fetchLineups, teamUuid, ...restProps }) => {
  const fetchMethod = () => fetchLineups(teamUuid)

  return (
    <Loader fetchMethod={fetchMethod} {...restProps}>
      {children}
    </Loader>
  )
}

LineupsLoader.propTypes = {
  children: PropTypes.node.isRequired,
  fetchLineups: PropTypes.func.isRequired,
  teamUuid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export default connect(
  ({ team }) => ({
    teamUuid: team.uuid,
  }),
  { fetchLineups: lineups.fetchLineups }
)(LineupsLoader)
